import React from "react";

const NotAvailable = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={64} height={64} fill="none" {...props}>
    <path stroke="#999" strokeMiterlimit={10} d="M11.651 41.35a21 21 0 1 1 29.7-29.7" />
    <path
      stroke="#999"
      strokeLinecap="square"
      strokeMiterlimit={10}
      d="M44.971 16.5A21.007 21.007 0 0 1 16.5 44.971M59.5 59.5 41.35 41.35M5.5 47.499 47.5 5.5"
    />
  </svg>
);

export default NotAvailable;
